import React from "react";
import { FormGroup, Label, ListGroup, ListGroupItem, Alert } from "reactstrap";
import moment from "moment";

import { Field } from "redux-form";

import { PaginatedList, PickupQuickView } from "pickups-ui-library";
import { FormField, FormFieldRadio } from "pickups-ui-library";
import { IconItem, StatusText } from "pickups-ui-library";
import * as Icons from "pickups-ui-library/styles/icons";
import { getPickupBlockByType } from "utils/helpers";

import FormNavigation from "../navigation.component";

import { requiredValidate } from "../../helpers";

// Select from the pickup blocks that were retrieved from zip search
export default class Step2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedId: undefined,
    };
  }

  render() {
    const { handleSubmit, onSelect, pickupBlockId, pickupType } = this.props;
    let pickupBlocks;

    pickupBlocks = getPickupBlockByType(this.props.pickupBlocks, pickupType);

    return (
      <form onSubmit={handleSubmit}>
        <FormGroup>
          {pickupBlocks ? (
            <>
              <PaginatedList>
                {pickupBlocks.map((pickupBlock) => {
                  const active = pickupBlock.id === pickupBlockId;

                  if (pickupBlock.stopsAvailable > 0) {
                    return (
                      <div
                        key={pickupBlock.id}
                        onClick={() => {
                          onSelect(pickupBlock.id);
                        }}
                      >
                        <IconItem
                          Icon={Icons.OnRoute}
                          className={active ? `active` : `disabled`}
                        >
                          <StatusText
                            title={moment
                              .utc(pickupBlock.date)
                              .format("dddd, MMMM Do, YYYY")}
                            subTitle={`${pickupBlock.zone.pickupType.label} Pickup`}
                          />
                        </IconItem>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </PaginatedList>
              <Field
                name="pickupBlockId"
                component="input"
                type="hidden"
                validate={[requiredValidate]}
              />
            </>
          ) : null}
          <FormNavigation {...this.props} />
        </FormGroup>
      </form>
    );
  }
}
